// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.step-indicator {
  width: 80%;
  margin-left: 10%;
}

.alert {
  border-radius: 8px;
}

.alert div:first-child {
  border-radius: 8px 0 0 8px;
}

.main-div {
  margin-left: 16.25%;
  margin-right: 16.25%;
  margin-top: 30px;
  margin-bottom: 20px;
}

.alert-container1 {
  margin-left: 70px;
}

@media (max-width: 1024px) {
  .mobilebox {
    margin-top: 60px;
    margin-left: -60px;
  }
}
@media only screen and (max-width: 1024px) and (max-width: 700px) and (min-width: 400px) {
  .acknowledgement-section {
    margin-left: -44px !important;
    width: 380px !important;
  }
}
@media only screen and (max-width: 1024px) and (max-width: 370px) and (min-width: 320px) {
  .acknowledgement-section {
    margin-left: -38px !important;
    width: 340px !important;
  }
}
@media (max-width: 500px) {
  .main-div {
    width: 70%;
    margin-left: 13.25%;
    margin-right: 12.25%;
    margin-top: 70px;
  }
}
.content {
  margin-top: -15px;
  padding: 0px !important;
}

.bluecontent {
  color: #1483D9;
}

.form-group {
  margin-left: 0px !important;
}

.validation-error {
  color: #cf2a2a !important;
  background: none !important;
  border: none !important;
}

.field {
  top: 693px;
  left: 437px;
  width: 560px !important;
  height: 36px;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  border-radius: 5px !important;
}
@media (max-width: 1024px) {
  .field {
    width: 280px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 920px) {
  .field {
    width: 370px !important;
  }
}

.textbox {
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  color: #191919;
  font-size: 16px;
  width: 560px !important;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  border: 1px solid #D1D2D3 !important;
  border-radius: 5px !important;
  padding: 2px;
}
@media (max-width: 1024px) {
  .textbox {
    width: 280px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 920px) {
  .textbox {
    width: 370px !important;
  }
}

.acknowledgement-section {
  width: 100%;
  background-color: #F1F2F3;
  padding: 15px 25px 15px 25px;
  border-radius: 5px !important;
  letter-spacing: 0.53px;
  text-align: left;
}

.icon-alert {
  width: 20px;
  height: 20px;
  color: #ffb81c;
}

.submit-section {
  height: 50px;
}

.labels-inline {
  display: inline-block;
}

.tooltipActive + .helper-text {
  display: block;
  width: 395px;
  padding: 10px 50px;
  margin-left: -190px;
  text-align: center !important;
  margin-bottom: -2px;
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 300px;
    margin-left: -145px;
    z-index: 0;
  }
}

.inline-labels {
  display: inline-block;
}

.tooltip-input {
  margin-left: 25px;
  position: relative !important;
}
@media (max-width: 1024px) {
  .tooltip-input {
    margin-left: 15px;
    position: relative !important;
  }
}

i.tooltip-icon {
  position: relative !important;
  margin-bottom: 18px;
}
@media (max-width: 1024px) {
  i.tooltip-icon {
    position: relative !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-inventory/manage-accounts/manage-accounts.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,UAAA;EACA,gBAAA;AAmJJ;;AAjJA;EACI,kBAAA;AAoJJ;;AAlJA;EACI,0BAAA;AAqJJ;;AAnJA;EACI,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAsJJ;;AApJA;EACI,iBAAA;AAuJJ;;AFlJI;EEFJ;IACI,gBAAA;IACA,kBAAA;EAwJF;AACF;AAvJA;EAEA;IACI,6BAAA;IACA,uBAAA;EAwJF;AACF;AAvJA;EAEI;IACI,6BAAA;IACA,uBAAA;EAwJN;AACF;AAnJA;EACI;IACI,UAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBAAA;EAqJN;AACF;AAlJA;EACI,iBAAA;EACA,uBAAA;AAoJJ;;AAjJA;EACI,cAAA;AAoJJ;;AAlJA;EACI,2BAAA;AAqJJ;;AA3IA;EACI,yBAAA;EACA,2BAAA;EACA,uBAAA;AA8IJ;;AA5IA;EACI,UAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,0DAAA;EACA,8DAAA;EAEA,6BAAA;AA8IJ;AFzMI;EEmDJ;IAYM,uBAAA;EA8IJ;AACF;AA7II;EAdJ;IAgBS,uBAAA;EA+IP;AACF;;AA5IA;EACI,8DAAA;EACA,cAAA;EACA,eAAA;EAEA,uBAAA;EACA,0DAAA;EACA,8DAAA;EACA,oCAAA;EACA,6BAAA;EACA,YAAA;AA8IJ;AF/NI;EEuEJ;IAaM,uBAAA;EA+IJ;AACF;AA9II;EAfJ;IAiBO,uBAAA;EAgJL;AACF;;AA7IA;EACI,WAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,sBAAA;EACA,gBAAA;AAgJJ;;AA7IA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAgJJ;;AA7IA;EACI,YAAA;AAgJJ;;AA9IA;EACI,qBAAA;AAiJJ;;AA9IA;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AAiJJ;AFzQI;EEkHJ;IASQ,YAAA;IACA,mBAAA;IACA,UAAA;EAkJN;AACF;;AA/IA;EACM,qBAAA;AAkJN;;AA/IA;EACI,iBAAA;EACA,6BAAA;AAkJJ;AFzRI;EEqIJ;IAKQ,iBAAA;IACA,6BAAA;EAmJN;AACF;;AAhJA;EACI,6BAAA;EACA,mBAAA;AAmJJ;AFpSI;EE+IJ;IAKQ,6BAAA;EAoJN;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.step-indicator {\n    width: 80%;\n    margin-left: 10%;\n}\n.alert{\n    border-radius: 8px;\n}\n.alert div:first-child {\n    border-radius: 8px 0 0 8px;\n  }\n.main-div {\n    margin-left: 16.25%;\n    margin-right: 16.25%;\n    margin-top: 30px;\n    margin-bottom: 20px;\n}\n.alert-container1{\n    margin-left: 70px;\n}\n@include respond-to (small) {\n.mobilebox{\n    margin-top: 60px;\n    margin-left: -60px\n}\n@media only screen and\n(max-width:700px) and (min-width:400px) { \n.acknowledgement-section{\n    margin-left: -44px !important;\n    width: 380px !important;\n}}\n@media only screen and\n(max-width: 370px) and (min-width:320px) { \n    .acknowledgement-section{\n        margin-left: -38px !important;\n        width: 340px !important;\n    }}\n\n}\n\n\n@media(max-width: 500px) {\n    .main-div {\n        width: 70%;\n        margin-left: 13.25%;\n        margin-right: 12.25%;\n        margin-top: 70px;\n    }\n}\n\n.content {\n    margin-top: -15px;\n    padding: 0px !important;\n}\n\n.bluecontent {\n    color: #1483D9;\n}\n.form-group{\n    margin-left:0px!important;\n}\n// #alert-container{\n//     background: #cf2a2a!important;\n// }\n// .alert-error {\n//     color: #cf2a2a!important;\n//     background: none!important;\n//     border:none!important;\n// }\n.validation-error{\n    color: #cf2a2a!important;\n    background: none!important;\n    border:none!important;\n}\n.field {\n    top: 693px;\n    left: 437px;\n    width: 560px !important;\n    height: 36px;\n    background: #FFFFFF 0% 0% no-repeat padding-box !important;\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\n    //border: 1px solid #D1D2D3 !important;\n    border-radius: 5px !important;\n    //opacity: 1;\n    //padding-top: 1px;\n    @include respond-to (small) {\n      width: 280px !important;\n    }\n    @media only screen and\n     (max-width: 1220px) and (min-width:920px) {\n         width: 370px !important;\n    }\n}\n\n.textbox {\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\n    color: #191919;\n    font-size: 16px;\n    //border: none;\n    width: 560px !important;\n    background: #FFFFFF 0% 0% no-repeat padding-box !important;\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\n    border: 1px solid #D1D2D3 !important;\n    border-radius: 5px !important;\n    padding: 2px;\n\n    @include respond-to (small){\n      width: 280px !important;\n    }\n    @media only screen and\n   (max-width: 1220px) and (min-width:920px) {\n       width: 370px !important;\n     }\n  }\n\n.acknowledgement-section {\n    width: 100%;//732px;\n    background-color: #F1F2F3;\n    padding: 15px 25px 15px 25px;\n    border-radius: 5px !important;\n    letter-spacing: 0.53px;\n    text-align: left;\n}\n\n.icon-alert {\n    width: 20px;\n    height: 20px;\n    color: #ffb81c;\n  }\n\n.submit-section {\n    height: 50px;\n}\n.labels-inline {\n    display: inline-block;\n}\n\n.tooltipActive + .helper-text {\n    display: block;\n    width: 395px;\n    padding: 10px 50px;\n    margin-left: -190px;\n    text-align: center !important;\n    margin-bottom: -2px;\n    \n    @include respond-to('small') {\n        width: 300px;\n        margin-left: -145px;\n        z-index:0;\n    }\n}\n  \n.inline-labels {\n      display: inline-block;\n}\n\n.tooltip-input {\n    margin-left: 25px;\n    position: relative !important;\n\n    @include respond-to('small') {\n        margin-left: 15px;\n        position: relative !important;\n    }\n}\n\ni.tooltip-icon {\n    position: relative !important;\n    margin-bottom: 18px;\n\n    @include respond-to('small') {\n        position: relative !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
